import { FormField } from './FormField';
import styles from './SelectField.module.css';

export interface SelectOption {
  value: string;
  label: string;
}

export interface SelectFieldProps {
  label: string;
  id: string;
  value: string;
  onChange: (value: string) => void;
  options: SelectOption[];
  name?: string;
  helpText?: string;
  error?: string;
  /** Overrides the accessible name (e.g. a member-scoped label). */
  'aria-label'?: string;
}

/**
 * Native `<select>` wrapped in a `FormField` for label + ARIA wiring. The native
 * control gives keyboard/AT users first-class option handling; the server remains
 * authoritative on whether a value is allowed.
 */
export function SelectField({
  label,
  id,
  value,
  onChange,
  options,
  name,
  helpText,
  error,
  'aria-label': ariaLabel,
}: SelectFieldProps) {
  return (
    <FormField
      label={label}
      id={id}
      {...(helpText ? { helpText } : {})}
      {...(error ? { error } : {})}
    >
      {({ controlProps }) => (
        <select
          {...controlProps}
          className={styles.select}
          name={name ?? id}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
        >
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      )}
    </FormField>
  );
}
